module.exports = __webpack_public_path__ + "img/1753@2x.a5e8d0c1.png";